import { render, staticRenderFns } from "./ExpertiseCreate.vue?vue&type=template&id=16de541c&scoped=true&"
import script from "./ExpertiseCreate.vue?vue&type=script&lang=js&"
export * from "./ExpertiseCreate.vue?vue&type=script&lang=js&"
import style0 from "./ExpertiseCreate.vue?vue&type=style&index=0&id=16de541c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de541c",
  null
  
)

component.options.__file = "ExpertiseCreate.vue"
export default component.exports